//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { email, required, minLength } from 'vuelidate/lib/validators'

export default {
	name: "email",
	data: () => ({
		email: "",
		password: "",
		passIsActive: false,
        emailIsActive: false,
        
	}),
	validations: {
		email: { email, required },
		password: { required, minLength: minLength(6) },
	},
	watch: {
		password(val) {
			val.length === 0
				? (this.passIsActive = false)
				: (this.passIsActive = true);
		},
		email(val) {
			val.length === 0
				? (this.emailIsActive = false)
				: (this.emailIsActive = true);
		},
	},
	methods: {
		async submitHandler() {
			if (this.$v.$invalid) {
				this.$v.$touch();
				return;
            }
			const formData = {
				email: this.email,
				password: this.password,
			};

			try {
				const res = await this.$store.dispatch("login", formData);
				this.$router.push('/markets');
			} catch (e) {
                const { code } = e;
                // if (code === 'auth/user-not-found') {
                //     this.$notify({ message: 'Пользователь с такой почтой уже есть', type: 'warning' });
				// }
				
				console.log("ERROR!!!", e);
			}
		},
	},
	mounted() {},
};
